// ShellError — top-level ErrorBoundary fallback when the SHELL itself crashes.
// Distinct from LaneError (per-lane fallback inside LaneShell).

interface ShellErrorProps {
  error?: Error;
  resetErrorBoundary?: () => void;
}

export function ShellError({ error, resetErrorBoundary }: ShellErrorProps): JSX.Element {
  return (
    <main className="grid min-h-screen place-items-center bg-surface-0 p-6">
      <div className="max-w-md space-y-3 text-center">
        <h1 className="text-lg font-semibold text-fg-default">Studio failed to start</h1>
        <p className="text-sm text-fg-muted">
          The shell hit an unrecoverable error. Reload the page; if the problem persists, contact
          the admin.
        </p>
        {error?.message ? (
          <pre className="rounded bg-surface-1 p-3 text-left text-xs text-danger-11">
            {error.message}
          </pre>
        ) : null}
        <button
          type="button"
          onClick={() => {
            if (resetErrorBoundary) resetErrorBoundary();
            else window.location.reload();
          }}
          className="rounded bg-accent-9 px-4 py-2 text-sm font-medium text-fg-on-accent focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-focus focus-visible:ring-offset-2 focus-visible:ring-offset-surface-0"
        >
          Reload
        </button>
      </div>
    </main>
  );
}
